// Lab-canonical, non-overlapping display palette (display label -> #RRGGBB).
// MUST stay in sync with export_worker.py CANONICAL_COLORS so the picker shows
// exactly what the export renders (WYSIWYG). Vessel markers deliberately share
// one pink (they read as a single vascular overlay); every other marker gets a
// distinct hue.
export const CANONICAL_COLORS: Record<string, string> = {
  Hoechst: "#3A7BFF", DAPI: "#3A7BFF", Nucleus: "#3A7BFF",
  // Vessel overlay — one shared pink.
  CD31: "#FF3EA0", CD105: "#FF3EA0", SMA: "#FF3EA0",
  // Primary markers — each distinct.
  GFAP: "#17E0E0", ASTROCYTE: "#17E0E0",
  AT8: "#FF3B30",
  NOTCH3: "#FF9500",
  MGP: "#A6E000",
  FN1: "#2ECC71",
  VEGFR3: "#FFD400",
  FABP4: "#B266FF",
  IBA1: "#00B8A0",
  OLIG2: "#6C5CFF",
  SMOC1: "#9B4DFF",
  C4a: "#FF7043",
  Ki67: "#E0A000",
};

// Canonical colour for a display label, else undefined (caller falls back).
export function canonicalColor(label: string): string | undefined {
  return CANONICAL_COLORS[label];
}

// The three markers that make up the shared vascular overlay. Treated as one
// group so a fresh pick turns all three on together — the zarr omero `active`
// flag historically omitted SMA, which left exports with an incomplete overlay.
export const VESSEL_MARKERS = new Set(["CD31", "CD105", "SMA"]);

export function isVessel(label: string): boolean {
  return VESSEL_MARKERS.has(label);
}
